module.exports = __webpack_public_path__ + "static/starTrek420-c3dbff2cbaf2308427c1222c95debf23.jpg";